import { trim } from 'lodash-es'

export class FeatureFlagsService<F extends string> {
  public isFeatureEnabled(featureFlag: F): boolean {
    const ffValue = localStorage.getItem(`tm::features::widget::${featureFlag}`)
    return Boolean(ffValue) && !['disabled', 'false', '0'].includes(trim(ffValue?.toLowerCase()))
  }
}

export default new FeatureFlagsService()
